// extracted by mini-css-extract-plugin
export default {"container":"BookPdf_container__K-ZXi","pdfs":"BookPdf_pdfs__VQ1SG"};